import { NavigationMenu } from '@rsmus/rsm-catt-ui/dist/components/types/navigationBar.types';
import { RoutePaths } from '../../../../utils/RoutePaths';
import { ApplicationLevelAdminWorkspacePermission, SystemAdminWorkspacePermission } from 'utils/users';

const GetHomeNavigationMenuData = (userAuthorizationValue : string[]): NavigationMenu[] => {
    const homeNavigationMenuData = [
        {
            icon: 'home',
            menuType: 'application',
            name: 'Home',
            redirectUrl: '/',
            tooltip: 'Home',
            visible: true,
        },

        {
            icon: 'group',
            menuType: 'application',
            name: 'Admin',
            tooltip: 'Admin',
            visible: true,
            listObjects: [
                {
                    header: "",
                    links:
                        [{
                            icon: '',
                            menuType: 'Admin',
                            name: 'Applications',
                            permissions: [
                                SystemAdminWorkspacePermission
                            ],
                            redirectUrl: `/${RoutePaths.Admin.Applications}`,
                            tooltip: 'Manage Applications',
                            visible: true,
                            userFeatures: userAuthorizationValue
                        }]
                },
                {
                    header: "",
                    links:
                        [{
                            icon: '',
                            menuType: 'Admin',
                            name: 'Workspaces',
                            permissions: [
                                SystemAdminWorkspacePermission, ApplicationLevelAdminWorkspacePermission
                            ],
                            redirectUrl: `/${RoutePaths.Admin.Workspaces}`,
                            tooltip: 'Manage Workspaces',
                            visible: true,
                            userFeatures: userAuthorizationValue
                        }]
                }]
        },
        {
            icon: 'info',
            menuType: 'application',
            name: 'Audit',
            tooltip: 'Audit',
            visible: true,
            listObjects: [
                {
                    header: "",
                    links:
                        [{
                            icon: '',
                            menuType: 'Admin',
                            name: 'Report Audit',
                            permissions: [
                                ApplicationLevelAdminWorkspacePermission, ApplicationLevelAdminWorkspacePermission
                            ],
                            redirectUrl: `/${RoutePaths.Admin.ReportAudit}`,
                            tooltip: 'View Report Audit',
                            visible: true,
                            userFeatures: userAuthorizationValue
                        }]
                },
                {
                    header: "",
                    links:
                        [{
                            icon: '',
                            menuType: 'Admin',
                            name: 'System Audit',
                            permissions: [
                                SystemAdminWorkspacePermission
                            ],
                            redirectUrl: `/${RoutePaths.Admin.SystemAudit}`,
                            tooltip: 'View System Audit',
                            visible: true,
                            userFeatures: userAuthorizationValue
                        }]
                }]
        }
    ];

    return homeNavigationMenuData;
};

export default GetHomeNavigationMenuData;
    
